/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Private Data Enclave API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {
  DatasetResponseList,
  DeleteProjectFileParams,
  DeleteProjectParams,
  DownloadProjectFileWithPresignedURLParams,
  FileVersionResponse,
  GetDatasetsInProjectParams,
  GetPIsOnProjectOverSizeLimit200,
  GetProjectsParams,
  PresignedUrlResponse,
  ProjectCreate,
  ProjectPatch,
  ProjectPut,
  ProjectResponse,
  ProjectResponseList,
  RequestBodyFileUpload,
  UploadProjectFileParams,
} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}

@Injectable({providedIn: 'root'})
export class ProjectsService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * Gets a list of all project metadata (matching query params) where
   * requesting user has a role on the project
   * @summary Get Projects
   */
  getProjects<TData = ProjectResponseList>(
    params?: GetProjectsParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getProjects<TData = ProjectResponseList>(
    params?: GetProjectsParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getProjects<TData = ProjectResponseList>(
    params?: GetProjectsParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getProjects<TData = ProjectResponseList>(
    params?: GetProjectsParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/projects`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/projects`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/projects`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Creates a new project
   * @summary Create Project
   */
  createProject<TData = unknown | void>(
    projectCreate: ProjectCreate,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  createProject<TData = unknown | void>(
    projectCreate: ProjectCreate,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  createProject<TData = unknown | void>(
    projectCreate: ProjectCreate,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  createProject<TData = unknown | void>(
    projectCreate: ProjectCreate,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/projects`, projectCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/projects`, projectCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/projects`, projectCreate, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Schedules a specified (project_id) project where requesting user is an owner on the project for permanent
   * deletion. If param: 'immediate' is True, a permanent and immediate delete occurs for the project as well as all its
   * associated files, datasets where this project is primary, and files in those datasets.
   * @summary Delete Project
   */
  deleteProject<TData = unknown>(
    projectId: string,
    params?: DeleteProjectParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  deleteProject<TData = unknown>(
    projectId: string,
    params?: DeleteProjectParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  deleteProject<TData = unknown>(
    projectId: string,
    params?: DeleteProjectParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  deleteProject<TData = unknown>(
    projectId: string,
    params?: DeleteProjectParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.delete<TData>(`${this.baseUrl}/projects/${projectId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(`${this.baseUrl}/projects/${projectId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.delete<TData>(`${this.baseUrl}/projects/${projectId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Gets project metadata for a specified (project_id) project where requesting user has a role on the project
   * @summary Get Project
   */
  getProject<TData = ProjectResponse>(projectId: string, options?: HttpClientBodyOptions): Observable<TData>;
  getProject<TData = ProjectResponse>(
    projectId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getProject<TData = ProjectResponse>(
    projectId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getProject<TData = ProjectResponse>(
    projectId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Patches project metadata for a specified (project_id) project
   * where requesting user is an owner on the project.
   * @summary Patch Project
   */
  patchProject<TData = unknown | void>(
    projectId: string,
    projectPatch: ProjectPatch,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  patchProject<TData = unknown | void>(
    projectId: string,
    projectPatch: ProjectPatch,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  patchProject<TData = unknown | void>(
    projectId: string,
    projectPatch: ProjectPatch,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  patchProject<TData = unknown | void>(
    projectId: string,
    projectPatch: ProjectPatch,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(`${this.baseUrl}/projects/${projectId}`, projectPatch, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(`${this.baseUrl}/projects/${projectId}`, projectPatch, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.patch<TData>(`${this.baseUrl}/projects/${projectId}`, projectPatch, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Updates project metadata for a specified (project_id) project
   * where requesting user is an owner on the project.
   * @summary Update Project
   */
  updateProject<TData = unknown | void>(
    projectId: string,
    projectPut: ProjectPut,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  updateProject<TData = unknown | void>(
    projectId: string,
    projectPut: ProjectPut,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  updateProject<TData = unknown | void>(
    projectId: string,
    projectPut: ProjectPut,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  updateProject<TData = unknown | void>(
    projectId: string,
    projectPut: ProjectPut,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`${this.baseUrl}/projects/${projectId}`, projectPut, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`${this.baseUrl}/projects/${projectId}`, projectPut, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`${this.baseUrl}/projects/${projectId}`, projectPut, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets metadata for all datasets that a user has permissions to view in a specified (project_id) project
   * @summary Get Datasets In Project
   */
  getDatasetsInProject<TData = DatasetResponseList>(
    projectId: string,
    params?: GetDatasetsInProjectParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getDatasetsInProject<TData = DatasetResponseList>(
    projectId: string,
    params?: GetDatasetsInProjectParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getDatasetsInProject<TData = DatasetResponseList>(
    projectId: string,
    params?: GetDatasetsInProjectParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getDatasetsInProject<TData = DatasetResponseList>(
    projectId: string,
    params?: GetDatasetsInProjectParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/datasets`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/datasets`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/datasets`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Uploads a document of specific type (document_type) to
   * a specified (project_id) project
   * @summary Upload Project File
   */
  uploadProjectFile<TData = FileVersionResponse>(
    projectId: string,
    requestBodyFileUpload: RequestBodyFileUpload,
    params: UploadProjectFileParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  uploadProjectFile<TData = FileVersionResponse>(
    projectId: string,
    requestBodyFileUpload: RequestBodyFileUpload,
    params: UploadProjectFileParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  uploadProjectFile<TData = FileVersionResponse>(
    projectId: string,
    requestBodyFileUpload: RequestBodyFileUpload,
    params: UploadProjectFileParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  uploadProjectFile<TData = FileVersionResponse>(
    projectId: string,
    requestBodyFileUpload: RequestBodyFileUpload,
    params: UploadProjectFileParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const formData = new FormData();
    formData.append(`file`, requestBodyFileUpload.file);

    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/projects/${projectId}/files`, formData, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/projects/${projectId}/files`, formData, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/projects/${projectId}/files`, formData, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Schedules a specified project file version for permanent deletion. If param: 'immediate' is True, a permanent and
   * immediate delete occurs from the database and file storage for the specified file version.
   * @summary Delete Project File
   */
  deleteProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    params?: DeleteProjectFileParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  deleteProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    params?: DeleteProjectFileParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  deleteProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    params?: DeleteProjectFileParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  deleteProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    params?: DeleteProjectFileParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.delete<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.delete<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Downloads a document of a specified (project_id) project
   * @summary Download Project File
   */
  downloadProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  downloadProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  downloadProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  downloadProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Uses pre-signed url to download project file. Otherwise, functionality is identical to the regular download
   * project file endpoint
   * @summary Download Project File With Presigned Url
   */
  downloadProjectFileWithPresignedURL<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    params: DownloadProjectFileWithPresignedURLParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  downloadProjectFileWithPresignedURL<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    params: DownloadProjectFileWithPresignedURLParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  downloadProjectFileWithPresignedURL<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    params: DownloadProjectFileWithPresignedURLParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  downloadProjectFileWithPresignedURL<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    params: DownloadProjectFileWithPresignedURLParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}/download-presigned`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}/download-presigned`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}/download-presigned`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Generates a pre-signed URL for downloading a project file.
   *
   * This endpoint returns a pre-signed URL that allows access to the file stored in MinIO. In addition, it
   * provides the size of the MinIO object (`stored_file_size`), which may differ from the original file size due
   * to compression. The `stored_file_size` represents the size of the object stored in MinIO,
   * whereas the `file_size` denotes the original size of the file as intended by the user during the upload.
   * @summary Generate Project File Download Link
   */
  generateProjectFileDownloadLink<TData = PresignedUrlResponse>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  generateProjectFileDownloadLink<TData = PresignedUrlResponse>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  generateProjectFileDownloadLink<TData = PresignedUrlResponse>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  generateProjectFileDownloadLink<TData = PresignedUrlResponse>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}/get-presigned-url`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}/get-presigned-url`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}/get-presigned-url`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Restores a document that was previously deleted from a specified (project_id) project
   * @summary Restore Project File
   */
  restoreProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  restoreProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  restoreProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  restoreProjectFile<TData = unknown>(
    projectId: string,
    fileVersionId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}/restore`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}/restore`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`${this.baseUrl}/projects/${projectId}/files/${fileVersionId}/restore`, undefined, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets a list of pi's associated with the project that are over the file size limit
   * @summary Get Pis On Project Over Size Limit
   */
  getPIsOnProjectOverSizeLimit<TData = GetPIsOnProjectOverSizeLimit200>(
    projectId: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getPIsOnProjectOverSizeLimit<TData = GetPIsOnProjectOverSizeLimit200>(
    projectId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getPIsOnProjectOverSizeLimit<TData = GetPIsOnProjectOverSizeLimit200>(
    projectId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getPIsOnProjectOverSizeLimit<TData = GetPIsOnProjectOverSizeLimit200>(
    projectId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/pi-size-limit`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/pi-size-limit`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/projects/${projectId}/pi-size-limit`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * If a project is scheduled to be deleted, this endpoint will remove it from the schedule
   * @summary Restore Project
   */
  restoreProject<TData = unknown>(projectId: string, options?: HttpClientBodyOptions): Observable<TData>;
  restoreProject<TData = unknown>(projectId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  restoreProject<TData = unknown>(
    projectId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  restoreProject<TData = unknown>(
    projectId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`${this.baseUrl}/projects/${projectId}/restore`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`${this.baseUrl}/projects/${projectId}/restore`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`${this.baseUrl}/projects/${projectId}/restore`, undefined, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}
